import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { styled, Button, Typography, Grid, Box } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import * as HrActions from '../../../store/actions/hr.action';
import { getUser } from '../../../store/selector/auth.selector';
import { getHrState } from '../../../store/selector/hr.selector';
import DynamicCrumbs from '../../../shared/components/ui/dashboard-layout/dynamic-crumbs';
import DynamicTabLink from '../../../shared/components/ui/dynamic-tabs/dynamic-tab-link';
import OptionsMenu from '../../../shared/components/ui/menu/options-menu';
import { HR_EXIT_INTERVIEW_OPTIONS } from '../../../shared/constants/hr-exit-interview-options';
import { HR_TABS_CONSTANT } from '../../../shared/constants/hr-tabs.constant';
import { HR_BP_TABS_CONSTANT } from '../../../shared/constants/hrbp-tabs.constant';

const styles = {
  header: {
    display: 'flex',
    flexDirection: { sm: 'row', xs: 'column' },
    justifyContent: 'space-between',
    alignItems: { sm: 'center', xs: 'flex-start' },
    mb: 3,
  },

  downloadOptionsButton: {
    padding: '0.5rem 1.5rem',
    borderRadius: '0.5rem',
    width: { sm: 'auto', xs: '100%' },
    mt: { sm: 0, xs: '2rem' },
  },
};

const Question = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.dark,
  fontSize: '1rem',
}));

const Answer = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '1rem',
  marginLeft: '1.5rem',
  fontWeight: 'bold',
}));

const HrExitInterview = () => {
  const dispatch = useDispatch();
  const user = useSelector(getUser);
  const {
    selected: { application },
  } = useSelector(getHrState);
  const { slug } = useParams<string>();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const moduleSelect = user.groups.includes('hr-bp') ? 'hr-bp' : 'hr';

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (slug) dispatch(HrActions.HrFetchApplication(slug));
  }, []);

  return (
    <>
      <Box sx={styles.header}>
        <Box>
          <DynamicCrumbs />

          <Typography sx={{ fontSize: '1.5rem' }}>
            {application?.lastname}, {application?.firstname}, {application?.middlename} -{' '}
            {application?.code}
          </Typography>
        </Box>

        <Button
          variant='contained'
          sx={styles.downloadOptionsButton}
          disableElevation
          onClick={handleClick}
          endIcon={<KeyboardArrowDownIcon />}
        >
          Actions
        </Button>

        <OptionsMenu
          open={open}
          handleClose={handleClose}
          anchorEl={anchorEl}
          optionItems={HR_EXIT_INTERVIEW_OPTIONS(slug)}
        />
      </Box>

      <DynamicTabLink tabs={moduleSelect === 'hr' ? HR_TABS_CONSTANT : HR_BP_TABS_CONSTANT} />

      <Grid
        container
        sx={{ p: '2rem', marginY: '1rem', backgroundColor: '#ffffff' }}
        rowGap={'2rem'}
      >
        {application?.interview_remarks.length > 0 ? (
          application?.interview_remarks.map((item: any, idx: any) => {
            return (
              <Grid item key={idx} xs={12}>
                <Question>{item.question.label}</Question>
                <Answer>{item.answer}</Answer>
              </Grid>
            );
          })
        ) : (
          <Grid
            item
            xs={12}
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
            <Typography color='gray' variant='h3'>
              No Available Data
            </Typography>
          </Grid>
        )}
      </Grid>
    </>
  );
};
export default HrExitInterview;
